import React, { useContext } from 'react'
import Card from '../../../common/card/Card'
import Button from '../../../common/button/Button'
import { useNavigate, useParams } from 'react-router-dom'
import { useGroupDashboardContext } from '../GroupDashboardContext'
import { TeamContext } from '../MenuTabs/MenuTabs'

const ReportCard = () => {

  const params = useParams()
  const teamId = params.team_id
  const navigate = useNavigate()
  const { filtersData } = useGroupDashboardContext()
  const { teamData } = useContext(TeamContext)
  
  const handleViewReports = () => {
    navigate(`/organization/${teamId}/reporting-group`)
  }
  
  return (
    <>
      { ( teamData.team_type !== 'msynclicenses' || teamData.can_view_reports ) && <Card className="msync-card--is-style-inline">
        <div className='msync-card__body'>
          <div className='msync-title msync-title--is-level-3'>Reports</div>
          <p>{ filtersData.home?.panel_reports_description }</p>
        </div>
        <div class="msync-card__footer msync-flex msync-flex--density-8">
          <Button
            onClick={()=>handleViewReports()}
          >
            View Reports
          </Button>
        </div>
      </Card> }
    </>
  )
}

export default ReportCard
